import React from 'react';
import PropTypes from 'prop-types';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMOReservationEditViewBlockSetting extends SMDashboardBaseView {
  
  constructor(props) {
    super(props);
    this.state = {
      reservation: null,
      ownerId: "",
      roomId: "",
      spaceId: "",
      errors: [],
    };
  }
  
  radioButtonDidChangeValue(e) {
    if (this.props.delegate && typeof this.props.delegate.radioButtonDidChangeValue === 'function'){
      this.props.delegate.radioButtonDidChangeValue(e);
    }
  }
  
  render() {
    let reservation = this.props.reservation;
    
    return(
      <div>
        <h3 className="dashboard-title2 mb20">ブロック設定</h3>
        <table className="dashboard-form-table mb50">
          <tbody>
            <tr>
              <th>ブロック理由<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
              <td>
                <input
                  type="radio"
                  value={SMConst.ReservationBlockType.Unavailable}
                  id="form-radio05__01"
                  name="method"
                  checked={false}
                  onChange={this.radioButtonDidChangeValue.bind(this)} />
                <label htmlFor="form-radio05__01" className="form-radio w150">利用不可</label>
                <p className='mb10'></p>
                <input
                  type="radio"
                  value={SMConst.ReservationBlockType.Manual}
                  id="form-radio05__02"
                  name="method"
                  checked={true}
                  onChange={this.radioButtonDidChangeValue.bind(this)} />
                <label htmlFor="form-radio05__02" className="form-radio">スペースマーケット以外の予約</label>
                <p className='dashboard-title__supplement mt10 mb10'>任意の予約情報をスペースマーケットで管理することができます。入力により手数料が発生することはありません。詳しくは <a href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.ManualReservation)} target='_blank'>{I18n.t("dashboard.label_000142")}</a> をご覧ください。</p>
              </td>
            </tr>
            {this.props.delegate.renderSpace()}
          </tbody>
        </table>  
      </div>
    );
  }
}
SMOReservationEditViewBlockSetting.propTypes = {
  reservation: PropTypes.object.isRequired,
  ownerId: PropTypes.string.isRequired,
  spaceId: PropTypes.string.isRequired,
  roomId: PropTypes.string.isRequired,
  delegate: PropTypes.object,
};
export default SMOReservationEditViewBlockSetting;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationEditViewBlockSetting.jsx